import { initializeApp } from 'firebase/app';
import {
  getMessaging,
  getToken,
  MessagePayload as FirebaseMessagePayload,
  Messaging,
  onMessage,
  Unsubscribe
} from 'firebase/messaging';
import {
  getAnalytics,
  logEvent as firebaseLogEvent
} from '@firebase/analytics';

class Firebase {
  private static _messaging: Messaging | undefined;
  private static _analytics: Messaging | undefined;
  private static _analyticsLegacy: Messaging | undefined;
  private static _unsubscribe: Unsubscribe | undefined;
  public static token: string | undefined;

  static initApp() {
    const doctornowApp = initializeApp(
      {
        apiKey: 'AIzaSyB6aWEDORByEd5BND_Y2lTPmSK0NXG4GeA',
        authDomain: 'baedalyakgook.firebaseapp.com',
        databaseURL: 'https://baedalyakgook.firebaseio.com',
        projectId: 'baedalyakgook',
        storageBucket: 'baedalyakgook.appspot.com',
        messagingSenderId: '681556968865',
        appId: '1:681556968865:web:5675041e5b55e48f9df7e0',
        measurementId: 'G-474S7WE361'
      },
      'doctornow'
    );
    const pharmacyApp = initializeApp(
      {
        apiKey: 'AIzaSyCA2pUfDuHzxRaCik1qvLUXEFAlzQN348s',
        authDomain: 'doctornow-pharmacy.firebaseapp.com',
        databaseURL: 'https://baedalyakgook.firebaseio.com',
        projectId: 'doctornow-pharmacy',
        storageBucket: 'doctornow-pharmacy.appspot.com',
        messagingSenderId: '220124731562',
        appId: '1:220124731562:web:84834b3e66f93c696518d3',
        measurementId: 'G-2S2WMTEX5X'
      },
      'doctornow-pharmacy'
    );
    this._messaging = getMessaging(doctornowApp);
    this._analytics = getAnalytics(pharmacyApp);
    this._analyticsLegacy = getAnalytics(doctornowApp);
  }

  static async initMessaging() {
    if (!this._messaging) return;
    try {
      const status = await Notification.requestPermission();
      if (status && status === 'granted') {
        const fcmToken = await getToken(this._messaging, {
          vapidKey:
            'BBwakEcP7nBIHjidXOfhhnMqWlJlBKwsVPmBCleNoMpEb1BCzpJYB5RBeUPck6j0pPSJvh4HalpBbjZD5GZ0ecQ'
        });
        this.token = fcmToken;
      }
    } catch (error) {
      console.log(error);
    }
  }

  static addListener(handler: (payload: MessagePayload) => void) {
    if (!this._messaging) throw new Error('no messaging');
    this._unsubscribe = onMessage(this._messaging, handler);
  }
  static removeListener() {
    if (!this._unsubscribe) return;
    this._unsubscribe();
  }
  static logEvent(eventName: any, eventParams?: Record<string, any>) {
    if (!this._analytics || !this._analyticsLegacy) return;
    firebaseLogEvent(this._analytics, eventName, eventParams);
    firebaseLogEvent(this._analyticsLegacy, eventName, eventParams);
  }
}

export default Firebase;
export type MessagePayload = FirebaseMessagePayload;
